const UA_HOSTNAME = "ua.viscosichalk.com";
const MAIN_HOSTNAME = "viscosichalk.com";
const UA_DOMAIN = `https://${UA_HOSTNAME}`;
const MAIN_DOMAIN = `https://${MAIN_HOSTNAME}`;
const STORAGE_KEY = "user-country-preference";
const COOKIE_DOMAIN = ".viscosichalk.com";
const COOKIE_MAX_AGE = 86400;

function cookieSet(name, value) {
  let s =
    encodeURIComponent(name) +
    "=" +
    encodeURIComponent(value) +
    "; path=/; domain=" +
    COOKIE_DOMAIN +
    "; max-age=" +
    COOKIE_MAX_AGE +
    "; SameSite=Lax";
  if (location.protocol === "https:") s += "; Secure";
  document.cookie = s;
}

function cookieGet(name) {
  const escaped = name.replace(/[$()*+.?[\\\]^{|}]/g, "\\$&");
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + escaped + "=([^;]*)")
  );
  return match ? decodeURIComponent(match[1]) : null;
}

function setCountryPreference(country) {
  const code = normalizeCountryCode(country);
  if (!code) return;
  try {
    cookieSet(STORAGE_KEY, code);
  } catch {
    /* ignore */
  }
}

function redirectToUA() {
  if (!isUAHost(window.location.hostname)) {
    window.location.replace(UA_DOMAIN);
  }
}

function redirectToMain() {
  if (!isMainHost(window.location.hostname)) {
    window.location.replace(MAIN_DOMAIN);
  }
}

function handleCountrySelection(e, country) {
  const code = normalizeCountryCode(country);
  if (!code) return;
  setCountryPreference(code);
  if (code === "UA" && window.location.hostname !== UA_HOSTNAME) {
    e?.preventDefault();
    redirectToUA();
  } else if (code !== "UA" && window.location.hostname !== MAIN_HOSTNAME) {
    e?.preventDefault();
    redirectToMain();
  }
}

function normalizeCountryCode(value) {
  const code = (value || "").trim().toUpperCase().slice(0, 2);
  return /^[A-Z]{2}$/.test(code) ? code : "";
}

function isMainHost(hostname) {
  return hostname === MAIN_HOSTNAME || hostname === "www." + MAIN_HOSTNAME;
}

function isUAHost(hostname) {
  return hostname === UA_HOSTNAME || hostname === "www." + UA_HOSTNAME;
}

function needsCrossHostRedirect(code) {
  if (!code) return false;
  if (code === "UA" && !isUAHost(window.location.hostname)) return true;
  if (code !== "UA" && !isMainHost(window.location.hostname)) return true;
  return false;
}

function syncCountryWithSelector(localizationForm, code) {
  const normalized = normalizeCountryCode(code);
  if (!normalized) return;
  const link = Array.from(
    localizationForm.querySelectorAll("a[data-value]")
  ).find(
    (a) => normalizeCountryCode(a.dataset.value) === normalized
  );
  if (!link) return;

  if (typeof localizationForm.onItemClick === "function") {
    localizationForm.onItemClick.call(localizationForm, {
      preventDefault() {},
      currentTarget: link,
    });
  } else {
    link.click();
  }
}

function watchPredefinedCountry(localizationForm) {
  const hiddenInput = localizationForm.querySelector(
    'input[name="country_code"]'
  );
  if (!hiddenInput) return;

  let lastApplied = "";

  const applyIfChanged = () => {
    const cookieCountry = normalizeCountryCode(cookieGet(STORAGE_KEY));
    const geoCountry = normalizeCountryCode(hiddenInput.value);
    const country = cookieCountry || geoCountry;
    if (!country) return;

    if (country !== lastApplied) {
      lastApplied = country;
      handleCountrySelection(null, country);
    }

    if (
      cookieCountry &&
      !needsCrossHostRedirect(cookieCountry) &&
      normalizeCountryCode(hiddenInput.value) !== cookieCountry
    ) {
      syncCountryWithSelector(localizationForm, cookieCountry);
    }
  };

  applyIfChanged();

  let ticks = 0;
  const maxTicks = 100;
  const timer = setInterval(() => {
    ticks += 1;
    applyIfChanged();
    if (ticks >= maxTicks) clearInterval(timer);
  }, 100);

  const observer = new MutationObserver(applyIfChanged);
  observer.observe(hiddenInput, {
    attributes: true,
    attributeFilter: ["value"],
  });

  window.addEventListener(
    "beforeunload",
    () => {
      observer.disconnect();
    },
    { once: true }
  );
}

document.querySelectorAll("localization-form").forEach((localizationForm) => {
  localizationForm.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", function (e) {
      const country =
        link.dataset.value ||
        link.textContent.trim().substring(0, 2).toUpperCase();
      handleCountrySelection(e, country);
    });
  });

  watchPredefinedCountry(localizationForm);
});
